import { render, staticRenderFns } from "./UpsertPosition.vue?vue&type=template&id=a9bf81d8&scoped=true"
import script from "./UpsertPosition.vue?vue&type=script&lang=ts"
export * from "./UpsertPosition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bf81d8",
  null
  
)

export default component.exports